/* Recall tracker (sections/ob-res-recalls.liquid): adds FDA infant formula recalls reported after
   the snapshot date (data-since) from openFDA, the FDA's public API (CORS open, no key needed for
   light traffic). Rows of one recall event are merged. Nothing shows if the request fails. */
(() => {
  'use strict';
  const list = document.querySelector('[data-obr-live]');
  if (!list) return;
  const since = (list.dataset.since || '').replace(/-/g, '');
  if (!/^\d{8}$/.test(since)) return;

  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const day = (d) => new Date(`${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}T12:00:00`);
  const fmt = (d) => day(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  const hazard = (reason) => {
    const r = reason.toLowerCase();
    if (r.includes('cronobacter')) return 'Cronobacter';
    if (r.includes('botul')) return 'Botulism';
    if (r.includes('cereulide') || r.includes('cereus')) return 'Cereulide';
    if (r.includes('salmonella')) return 'Salmonella';
    if (r.includes('vitamin') || r.includes('iron') || r.includes('level')) return 'Nutrient level';
    if (r.includes('label') || r.includes('undeclared') || r.includes('notification')) return 'Labeling';
    return 'Other';
  };

  const q = `product_description:"infant formula" AND report_date:[${since} TO 20991231]`;
  const url = `https://api.fda.gov/food/enforcement.json?search=${encodeURIComponent(q)}&sort=report_date:desc&limit=50`;

  fetch(url)
    .then((r) => (r.ok ? r.json() : { results: [] }))
    .then((d) => {
      const events = new Map();
      (d.results || []).forEach((r) => {
        if (!/infant formula/i.test(r.product_description || '')) return;
        const k = r.event_id || r.recall_number;
        if (!events.has(k)) events.set(k, { ...r, products: [] });
        events.get(k).products.push((r.product_description || '').split(/[.;]/)[0]);
      });
      const html = [...events.values()].map((r) => {
        const h = hazard(r.reason_for_recall || '');
        const products = [...new Set(r.products)].join('; ');
        const date = r.recall_initiation_date || r.report_date;
        return `<li class="obr-recall is-live is-new">
          <div class="obr-recall__meta"><time datetime="${esc(date)}">${fmt(date)}</time><span class="obr-recall__where">United States · FDA</span></div>
          <div class="obr-recall__main">
            <h4 class="obr-recall__brand">${esc(r.recalling_firm)}</h4>
            <p class="obr-recall__prod">${esc(products.length > 220 ? products.slice(0, 217) + '…' : products)}</p>
            <p class="obr-recall__reason">${esc(r.reason_for_recall)}</p>
            <ul class="obr-tags" role="list"><li class="obr-tag obr-tag--live">New</li><li class="obr-tag obr-tag--hz obr-tag--${h.toLowerCase().replace(/ /g, '-')}">${esc(h)}</li>${r.classification ? `<li class="obr-tag">${esc(r.classification)}</li>` : ''}${r.status ? `<li class="obr-tag">${esc(r.status)}</li>` : ''}</ul>
            <a class="obr-recall__link" href="https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts" target="_blank" rel="noopener">FDA recalls list<svg class="obr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3h6v6M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg><span class="obc-sr"> (opens in a new tab)</span></a>
          </div>
        </li>`;
      }).join('');
      if (html) list.insertAdjacentHTML('afterbegin', html);
    })
    .catch(() => {});
})();
